module.exports = __webpack_public_path__ + "img/laptop-01.7678929c.svg";